export default __webpack_public_path__ + "static/media/raport.b1ef9a88.svg";